<template>
  <div>
    <div v-if="headerbar" class="row row-table-title">
      <div
        class="col-12 margin-tb section-title dark-green-title"
        style="padding-top: 0px; padding-bottom: 0px;"
      >
        <div class="pull-left">
          <h2
            class="white-font row-table-font-margins"
            style="
              font-size: 20px;
              font-family: inherit;
              font-weight: 400;
              line-height: 1;
            "
          >
            Expenses
          </h2>
        </div>

        <div class="pull-right" style="display: inline-flex;">
          <expense-form-link
            :component="component"
            :building-id="buildingId"
            class="test"
            href="#"
            data-toggle="tooltip"
            data-placement="top"
            title="Included in monthly fee"
            >Create Expense</expense-form-link
          >

          <additional-expense-form-link :building-id="buildingId"
            >Create Additional Expense</additional-expense-form-link
          >

          <a
            style="float: right; color: white; font-size: 14px;"
            @click.prevent="createpdf()"
            >Download</a
          >
        </div>
      </div>
    </div>

    <div class="table-responsive">
      <table
        id="expenses-table"
        :ref="expenses"
        class="table table-striped table-condensed table-border"
      >
        <thead class="thead-style" v-bind:class="{ 'dark-green': dark }">
          <tr>
            <th scope="col"></th>
            <th scope="col"></th>
            <th scope="col">Jan</th>
            <th scope="col">Feb</th>
            <th scope="col">Mar</th>
            <th scope="col">Apr</th>
            <th scope="col">May</th>
            <th scope="col">Jun</th>
            <th scope="col">Jul</th>
            <th scope="col">Aug</th>
            <th scope="col">Sep</th>
            <th scope="col">Oct</th>
            <th scope="col">Nov</th>
            <th scope="col">Dec</th>
            <th scope="col">Total</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(expenseFee, key, index) in getExpenses">
            <td scope="row">
              <strong> {{ expenseFee.expenseName }}</strong>
            </td>
            <td></td>
            <td v-for="(fee, key2) in expenseFee.fees">
              <div v-if="key2 < 12">
                <div v-if="fee == 0">
                  -
                </div>
                <div v-else>
                  {{ $filters.toCurrency(fee) }}
                </div>
              </div>
              <div v-else>
                <strong>
                  <div v-if="fee == 0">
                    -
                  </div>
                  <div v-else>
                    {{ $filters.toCurrency(fee) }}
                  </div>
                </strong>
              </div>
            </td>
          </tr>
          <tr>
            <td scope="row">
              <strong>
                Total
              </strong>
            </td>
            <td></td>
            <td v-for="total in totalFees">
              <strong>
                <div v-if="total == 0">
                  -
                </div>
                <div v-else>
                  {{ $filters.toCurrency(total) }}
                </div>
              </strong>
            </td>
          </tr>
        </tbody>
      </table>

      <modal
        name="hello-world"
        @before-open="beforeOpen"
        height="auto"
        :minHeight="600"
      >
        <div class="" id="expenseModal" role="dialog">
          <div class="">
            <!-- Modal content-->
            <div class="modal-content">
              <div class="modal-header">
                <button
                  type="button"
                  class="close"
                  @click="$emit('close')"
                  data-dismiss="modal"
                >
                  &times;
                </button>
                <h4 class="modal-title">Add new expense</h4>
              </div>
              <div class="modal-body-expense">
                <div class="row" style="padding: 5px;">
                  <expense-form
                    :createpdf="createpdf"
                    :building-id="buildingId"
                    :expense-type-id="expenseTypeId"
                    :month-prop="monthParam"
                  ></expense-form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </modal>
    </div>
  </div>
</template>
<script>
$(document).ready(function () {
  $('[data-toggle="tooltip"]').tooltip();
});

export default {
  props: [
    "buildingId",
    "route",
    "period",
    "filter",
    "component",
    "headerbar",
    "dark",
  ],
  data: function () {
    return {
      expenseFees: [],
      totalFees: [],
      index: 0,
      isModalVisible: true,
      expenseTypeId: 0,
      monthParam: 0,
    };
  },
  watch: {
    value(val) {
      this.$emit("update:buildingId", val);
    },
    buildingId(val) {
      this.value = val;
      this.fetchStatement();
    },
  },
  mounted() {
    if (this.buildingId) this.fetchStatement();
    //this.propertyHistory = JSON.parse(this.propertyAttribute)

    //console.log(this.propertyAttribute)
    //this.propertyHistory = this.propertyAttribute
  },

  methods: {
    createpdf() {
      return true;
    },
    beforeOpen(event) {
      this.expenseTypeId = event.params.expensetypeid;
      this.monthParam = event.params.month + 1;
    },
    showModal() {
      this.isModalVisible = true;
      alert(this.isModalVisible);
    },
    closeModal() {
      this.isModalVisible = false;
    },
    fetchStatement: function () {
      this.mute = true;
      var request = "/expenses/totalexpenses";

      // if(this.route=="home")
      //   request = '/home/statment/get/';
      request = request + "?id=" + this.buildingId + "&period=" + this.period;
      /*  if(this.period == 2)
                      request = request +'/'+this.period;
                  else
                      request = request +'?id='+this.buildingId;*/
      this.$http
        .get(request, {
          id: 1,
        })
        .then(({ data }) => {
          this.mute = false;
          //this.contacts = data.contacts;
          this.mute = false;
          // let myObjStr = JSON.stringify(data.expenseFees);
          this.expenseFees = data.expenseFees;
          this.totalFees = data.totalFees;
        });
    },
    showModalTemp: function (expenseId, month) {
      this.$modal.show("hello-world", {
        expensetypeid: expenseId,
        month: month,
      });
      //alert("Id " + expenseId + " month " + month);
      //this.isModalVisible = true;
    },
    show() {
      this.$modal.show("hello-world");
    },
    hide() {
      this.$modal.hide("hello-world");
    },
  },
  computed: {
    toolTipText: function () {
      return "voila!";
    },

    getExpenses() {
      if (this.filter) {
        var expenseFees = this.expenseFees.filter((expenseFee) => {
          return expenseFee.expenseName
            .toLowerCase()
            .includes(this.filter.toLowerCase());
        });

        return expenseFees;
      } else return this.expenseFees;
    },
    total: function () {
      //console.log(this.expenseFees);
      return this.expenseFees[0].reduce(function (total, fees) {
        return total + fees[0];
      }, 0);
    },
  },
}; // Our Javascript logic
</script>
